import { useModalStackStore } from "src/stores/modalStackStore";

// Dropdowns consume printable keys for typeahead ("u" → USD), whether focus is
// on the closed trigger or on an option in the open list.
const SELECT_CONTROL_SELECTOR =
  '[aria-haspopup="listbox"], [role="combobox"], [role="listbox"], [role="option"]';

/**
 * Returns true if the currently focused element is a text input,
 * textarea, contentEditable element, or dropdown. Used to suppress keyboard
 * shortcuts when the user is typing.
 */
export function isInputElement(target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) return false;
  if (
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.tagName === "SELECT" ||
    target.isContentEditable ||
    target.closest(SELECT_CONTROL_SELECTOR)
  ) {
    return true;
  }

  // Keyboard events crossing a shadow boundary are retargeted to the shadow
  // host. document.activeElement behaves the same way, so follow the focused
  // element through open shadow roots before deciding that the user is not
  // typing.
  return isInputElement(target.shadowRoot?.activeElement ?? null);
}

/**
 * Returns true if any modal/dialog is currently open, using the modal
 * stack store (which all Dialog components register with).
 */
export function hasOpenModal(): boolean {
  return useModalStackStore.getState().stack.length > 0;
}
